import { refreshAccessToken } from '@/services/user';
import { history } from '@umijs/max';

let isRefreshing = false;
let subscribers: ((token: string) => void)[] = [];

function onRefreshed(token: string) {
  subscribers.forEach((cb) => cb(token));
  subscribers = [];
}

export async function getNewToken() {
  if (!isRefreshing) {
    isRefreshing = true;
    try {
      const res = await refreshAccessToken();
      if (res.success && res.data?.accessToken) {
        const token = res.data.accessToken;
        localStorage.setItem('accessToken', token);
        onRefreshed(token);
        return token;
      }
      throw new Error('Refresh failed');
    } catch {
      // 刷新失败时，也要通知所有排队中的请求“失败了”
      onRefreshed('');
      localStorage.removeItem('accessToken');
      if (history.location.pathname !== '/user/login') {
        history.push('/user/login');
      }
      return null;
    } finally {
      isRefreshing = false;
    }
  }
  // 排队中的请求需要返回新 Token
  return new Promise<string>((resolve) => {
    subscribers.push((token: string) => {
      resolve(token);
    });
  });
}